import { render, staticRenderFns } from "./LendBook.vue?vue&type=template&id=08380324&scoped=true&"
import script from "./LendBook.vue?vue&type=script&lang=js&"
export * from "./LendBook.vue?vue&type=script&lang=js&"
import style0 from "./LendBook.vue?vue&type=style&index=0&id=08380324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08380324",
  null
  
)

export default component.exports